import $ from 'jquery'
import 'slick-carousel'

$(document).ready(dhsv_vc_video_slider_container())

function dhsv_vc_video_slider_container() {
  $('.dhsv_vc_video_slider_container').each(function () {
    var $el = $(this)
    $el.slick({
      dots: true,
      infinite: true,
      nextArrow:
        '<div class="slick-arrow next"><i class="bts bt-angle-right"></i></div>',
      prevArrow:
        '<div class="slick-arrow prev"><i class="bts bt-angle-left"></i></div>',
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    })
  })
}
